// extracted by mini-css-extract-plugin
export default {"wrapper":"Instructor_wrapper__o2y5a","image":"Instructor_image__bLsED","info":"Instructor_info__I4xGl","name":"Instructor_name__mHLOV","position":"Instructor_position__8ivO5"};